import api from "../auth/api";


export const internalApi = {
  listThreads: (params) => api.get("/internal/threads", { params }),
  createThread: (payload) => api.post("/internal/threads", payload),
  getThread: (id) => api.get(`/internal/threads/${id}`),
  patchThread: (id, payload) => api.patch(`/internal/threads/${id}`, payload),

  listMessages: (id) => api.get(`/internal/threads/${id}/messages`),
  postMessage: (id, payload) => api.post(`/internal/threads/${id}/messages`, payload),

  listParticipants: (id) => api.get(`/internal/threads/${id}/participants`),
  addParticipant: (id, payload) => api.post(`/internal/threads/${id}/participants`, payload),
  patchParticipant: (id, userId, payload) =>
    api.patch(`/internal/threads/${id}/participants/${userId}`, payload),
  removeParticipant: (id, userId) =>
    api.delete(`/internal/threads/${id}/participants/${userId}`),

  listTasks: (id) => api.get(`/internal/threads/${id}/tasks`),
  createTask: (id, payload) => api.post(`/internal/threads/${id}/tasks`, payload),
  patchTask: (taskId, payload) => api.patch(`/internal/tasks/${taskId}`, payload),
  deleteTask: (taskId) => api.delete(`/internal/tasks/${taskId}`),

  getOrCreateForLead: (leadId) => api.post(`/leads/${leadId}/internal-thread`),
  listUsers: (q = "") => api.get("/users", { params: { q } }),
};
